import React from 'react';
import {
  X,
  Grid3X3,
  Package,
  Users,
  ShoppingCart,
  BarChart3,
  CreditCard,
  HelpCircle,
  FileText,
} from 'lucide-react';

const AdminSidebar = ({ sidebarOpen, setSidebarOpen, location, navigate }) => {
  const menuItems = [
    { name: 'Overview', path: '/admin', icon: Grid3X3 },
    { name: 'Products', path: '/admin/products', icon: Package },
    { name: 'Customers', path: '/admin/customers', icon: Users },
    { name: 'Orders', path: '/admin/orders', icon: ShoppingCart },
    { name: 'Analytics', path: '/admin/analytics', icon: BarChart3 },
    { name: 'Support Chat', path: '/admin/chat', icon: Users },
    { name: 'AI Knowledge', path: '/admin/knowledge', icon: FileText },
    { name: 'Payments', path: '/admin/activity', icon: CreditCard },
  ];

  const bottomItems = [
    { name: 'Coupons', path: '/admin/coupons', icon: CreditCard },
    { name: 'Help Center', path: '/admin/help', icon: HelpCircle },
    // { name: "Settings", path: "/admin/settings", icon: Settings },
    { name: 'Report', path: '/admin/reports', icon: FileText },
  ];

  const isActive = (path) => {
    if (path === '/admin') {
      return location?.pathname === '/admin';
    }
    return location?.pathname?.startsWith(path);
  };

  const handleNavigation = (path) => {
    if (navigate) {
      navigate(path);
    }
    if (setSidebarOpen) {
      setSidebarOpen(false);
    }
  };

  return (
    <>
      <div
        className={`fixed inset-y-0 left-0 z-50 w-[243px] bg-white overflow-y-auto hide-scrollbar border-r border-[#50505066] transform transition-transform duration-300 ease-in-out ${sidebarOpen ? 'translate-x-0' : '-translate-x-full'
          } lg:translate-x-0 flex flex-col`}
      >
        <div className="w-full flex flex-col items-center px-4 pt-8">
          <img
            src="/assets/admin/logo-admin.svg"
            alt="logo"
            className="w-[180px]"
          />
          <button
            onClick={() => setSidebarOpen && setSidebarOpen(false)}
            className="lg:hidden absolute top-4 right-4 text-gray-400 hover:text-gray-600 transition-colors"
          >
            <X className="w-5 h-5" />
          </button>
        </div>

        <div className="flex-1">
          <div className="px-11 py-4">
            <p className="text-[18px] leading-[22px] font-normal inter text-[#878A93] -tracking-wider">
              Main Menu
            </p>
          </div>

          <nav className="px-5">
            <ul className="space-y-4">
              {menuItems.map((item, index) => {
                const Icon = item.icon;
                const active = isActive(item.path);
                return (
                  <li key={item.name}>
                    <button
                      onClick={() => handleNavigation(item.path)}
                      className={`w-full flex items-center gap-4 px-6 py-3 text-[18px] tracking-[-0.72px] poppins rounded-[10px] transition-all duration-200 ${active
                          ? 'bg-[#00001D33] text-[#00001D] font-semibold'
                          : 'text-[#878A93] hover:bg-gray-100 hover:text-[#00001D] font-normal'
                        }`}
                    >
                      <Icon
                        className={`w-5 h-5 ${active ? 'text-[#00001D]' : 'text-[#878A93]'
                          }`}
                      />
                      {item.name}
                    </button>
                  </li>
                );
              })}
            </ul>
          </nav>

          <div className="px-6 py-4">
            <div className="border-t border-[#666666]"></div>
          </div>

          <div className="px-11 py-2">
            <p className="text-[18px] leading-[22px] font-normal inter text-[#878A93] -tracking-wider">
              Preference
            </p>
          </div>

          <nav className="px-4 pb-6">
            <ul className="space-y-1">
              {bottomItems.map((item) => {
                const Icon = item.icon;
                const active = isActive(item.path);

                return (
                  <li key={item.name}>
                    <button
                      onClick={() => handleNavigation(item.path)}
                      className={`w-full flex items-center gap-4 px-6 py-3 text-[18px] tracking-[-0.72px] poppins rounded-[10px] transition-all duration-200 ${active
                          ? 'bg-[#00001D33] text-[#00001D] font-semibold'
                          : 'text-[#878A93] hover:bg-gray-100 hover:text-[#00001D] font-normal'
                        }`}
                    >
                      <Icon
                        className={`w-5 h-5 ${active ? 'text-[#00001D]' : 'text-[#878A93]'
                          }`}
                      />
                      {item.name}
                    </button>
                  </li>
                );
              })}
            </ul>
          </nav>
        </div>
      </div>

      {sidebarOpen && (
        <div
          className="fixed inset-0 z-40 bg-black bg-opacity-50 lg:hidden"
          onClick={() => setSidebarOpen && setSidebarOpen(false)}
        />
      )}
    </>
  );
};

export default AdminSidebar;
